import React from 'react';
import PropTypes from 'prop-types';
import FaTh from 'react-icons/lib/fa/th';
import { Link, withRouter } from 'react-router-dom';


const MediaNav = ({ location, gridUrl, itemUrls }) => {
  return (
    <div className="topic-tree-media-nav">
      <span className="text-uppercase mx-2">Viewing:</span>
      {itemUrls.map((url, idx) => (
        location.pathname === url
          ? <span key={url} className="mx-2">{idx + 1}</span>
          : <Link key={url} to={url} className="mx-2">{idx + 1}</Link>
      ))}
      <span className="mx-2 divider-vertical" style={{ height: 14 }} />
      <Link to={gridUrl} className="text-uppercase mx-2">
        <span className="mr-2" style={{ position: 'relative', top: -1 }}><FaTh /></span>
        Back to Grid
      </Link>
    </div>
  );
};

MediaNav.propTypes = {
  location: PropTypes.object,
  gridUrl: PropTypes.string,
  itemUrls: PropTypes.arrayOf(PropTypes.string),
};

export default withRouter(MediaNav);



// WEBPACK FOOTER //
// ./src/components/TopicTree/MediaNav.js